import {IPaiementWebServiceClient, PaiementDto} from "@resources/resources";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {Component} from "@angular/core";
import * as lodash from "lodash";
import {ActivatedRoute} from "@angular/router";


@Component({
  selector: 'laboratoire-component',
  templateUrl: './laboratoire.component.html',
  host: {'class': 'page'}
})
export class LaboratoireComponent {
  paiements: Array<PaiementDto>;
  factureForm: FormGroup;
  errorSaisie: boolean;
  numLabo: any;
  numDossier: any;
  numDossier2: any;
  numDossier3: any;
  numDossier4: any;
  numDossier5: any;
  numDossier6: any;
  numDossier7: any;
  numDossier8: any;
  numDossier9: any;
  numDossier10: any;
  affichageNext: boolean;
  firstPaiement: PaiementDto;
  total: number;

  constructor(private fb: FormBuilder, private paiementWebServiceClient: IPaiementWebServiceClient,
              private activatedRoute: ActivatedRoute) {

    this.paiements = activatedRoute.snapshot.data['paiements'];
  }

  ngOnInit() {
    let laboratoire = this.paiements.reduceRight((r, p) => p.code, null);
    let dossiers = this.paiements.filter(p => p.code == laboratoire).map(p => p.numero);
    while (dossiers.length < 10) {
      dossiers.push(null);
    }

    this.total = 0;
    this.affichageNext = false;
    this.errorSaisie = false;
    this.factureForm = this.fb.group({
      numLabo: [laboratoire, Validators.required],
      numDossier1: [dossiers[0], Validators.required],
      numDossier2: dossiers[1],
      numDossier3: dossiers[2],
      numDossier4: dossiers[3],
      numDossier5: dossiers[4],
      numDossier6: dossiers[5],
      numDossier7: dossiers[6],
      numDossier8: dossiers[7],
      numDossier9: dossiers[8],
      numDossier10: dossiers[9],
    });

    this.factureForm.valueChanges.subscribe(() => this.errorSaisie = false);

    if (this.paiements.length) {
      this.handlePaiements(this.paiements.slice(0, 10));
    }
  }

  submit() {
    let values = this.factureForm.value;
    this.loadPaiements(values);
  }

  loadPaiements(values: any) {
    let numDossiers: any[] = [];

    if (values.numDossier1 != null && lodash.indexOf(numDossiers, values.numDossier1) == -1) {
      numDossiers.push(values.numDossier1);
    }
    if (values.numDossier2 != null && lodash.indexOf(numDossiers, values.numDossier2) == -1) {
      numDossiers.push(values.numDossier2);
    }
    if (values.numDossier3 != null && lodash.indexOf(numDossiers, values.numDossier3) == -1) {
      numDossiers.push(values.numDossier3);
    }
    if (values.numDossier4 != null && lodash.indexOf(numDossiers, values.numDossier4) == -1) {
      numDossiers.push(values.numDossier4);
    }
    if (values.numDossier5 != null && lodash.indexOf(numDossiers, values.numDossier5) == -1) {
      numDossiers.push(values.numDossier5);
    }
    if (values.numDossier6 != null && lodash.indexOf(numDossiers, values.numDossier6) == -1) {
      numDossiers.push(values.numDossier6);
    }
    if (values.numDossier7 != null && lodash.indexOf(numDossiers, values.numDossier7) == -1) {
      numDossiers.push(values.numDossier7);
    }
    if (values.numDossier8 != null && lodash.indexOf(numDossiers, values.numDossier8) == -1) {
      numDossiers.push(values.numDossier8);
    }
    if (values.numDossier9 != null && lodash.indexOf(numDossiers, values.numDossier9) == -1) {
      numDossiers.push(values.numDossier9);
    }
    if (values.numDossier10 != null && lodash.indexOf(numDossiers, values.numDossier10) == -1) {
      numDossiers.push(values.numDossier10);
    }

    this.paiementWebServiceClient.findPaiementClient(values.numLabo, numDossiers).subscribe(
      data => this.handlePaiements(data),
      err => {
        this.errorSaisie = true;
        console.log(err)
      });
  }

  handlePaiements(data: PaiementDto[]): void {
    this.total = 0;
    this.paiements = data;
    console.log(data);

    for (let paiement of this.paiements) {
      if (paiement.type == "AVOIR") {
        paiement.montant = "-" + paiement.montant;
      }
      console.log(Number.parseFloat(paiement.montant))
      this.total = this.total + Number.parseFloat(paiement.montant);
    }

    this.firstPaiement = this.paiements[0]
    if (data === null || data.length === 0) {
      this.errorSaisie = true;
      this.affichageNext = false;
    } else {
      this.affichageNext = true;
      this.errorSaisie = false;
    }
  }

  public doSomething(event: any): void {
    this.affichageNext = false;
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-paiement-factures/digicerba-paiement-factures-web/src/angular/cerba/src/app/pages/cerba/pages/laboratoire/laboratoire.component.ts